import React from "react";

import Box from "@mui/material/Box";

import PortList from "./PortList";

const tableConfig = [
  {
    label: "Sr No",
    key: "sr_no",
  },
  {
    label: "Name",
    key: "common_name",
  },
  {
    label: "Tube Color",
    key: "tube_color",
    type: "color",
  },
  {
    label: "Ribbon",
    key: "ribbon",
  },
  {
    label: "Fiber Color",
    key: "fiber_color",
    type: "color",
  },
  {
    label: "A End",
    key: "conn__to_A_end",
    type: "port_number",
  },
  {
    label: "B End",
    key: "conn__to_B_end",
    type: "port_number",
  },
  {
    label: "A Trace",
    key: "port_id_A_end",
    // need this to show / hide connection btn if port not connected
    lc_entry_val: "conn__to_A_end",
    // need this to delete other port conn data on success
    other_port_id: "port_id_B_end",
    type: "get_connection_two_end",
  },
  {
    label: "B Trace",
    key: "port_id_B_end",
    // need this to show / hide connection btn if port not connected
    lc_entry_val: "conn__to_B_end",
    // need this to delete other port conn data on success
    other_port_id: "port_id_A_end",
    type: "get_connection_two_end",
  },
];

/**
 * Parent:
 *    ElementPortDetails
 */
const CablePortDetails = ({ portDetails }) => {
  return (
    <Box p={1}>
      <PortList portList={portDetails} tableConfig={tableConfig} />
    </Box>
  );
};

export default CablePortDetails;
